<template>
    <div class="one-to-one__section">

        <h2 class="one-to-one__section-title">{{ $t("balance") }}</h2>

        <div class="one-to-one__section-description--balance">
            <h3>{{ capitalize(balanceData.quality) }}</h3>
            <p>{{ description }}</p>
        </div>

        <div
            class="chart-balance"
            :class="balanceStatusClass">

            <div class="user-artwork chart-balance__friends">
                <span class="user-artwork__value">{{ Math.round(balanceData.reversedAttractedTo_distance) }}%</span>
                <img
                    class="user-artwork__svg"
                    :src="artworkFriendUrl"
                    alt="" />
            </div>

            <div class="user-artwork chart-balance__user">
                <span class="user-artwork__value">{{ Math.round(balanceData.attractedTo_distance) }}%</span>
                <img
                    class="user-artwork__svg"
                    :src="artworkUserUrl"
                    alt="" />
            </div>

            <div class="balance">
                <img
                    class="balance__tray"
                    src="@/assets/images/artworks/balance-chart/balance-tray.svg"
                    alt="">
                <img
                    class="balance__axe"
                    src="@/assets/images/artworks/balance-chart/balancea-axe.svg"
                    alt="">
            </div>

        </div>

    </div>
</template>

<script>

export default {
    name: "BalanceSection",
    props: {
        balanceData: {
            type: Object,
            required: true
        },
    },
    data () {
        return {};
    },
    computed: {
        artworkFriendUrl() {
            return require(`@/assets/images/artworks/gender/${(this.balanceData.match_gender === "F") ? "female" : "male"}-dotted.svg`);
        },
        artworkUserUrl() {
            return require(`@/assets/images/artworks/gender/${(this.balanceData.gender === "F") ? "female" : "male"}-dotted.svg`);
        },
        balanceDirection() {
            if (this.balanceData.reversedAttractedTo_distance > this.balanceData.attractedTo_distance) {
                return "left";
            }

            if (this.balanceData.reversedAttractedTo_distance < this.balanceData.attractedTo_distance) {
                return "right";
            }

            return;
        },
        balancePower() {
            if (this.balanceData.delta > 15 && this.balanceData.delta <= 30) {
                return "low";
            }

            if (this.balanceData.delta > 30) {
                return "high";
            }

            return;
        },
        balanceStatusClass() {
            if (this.balanceDirection && this.balancePower) {
                return `chart-balance--${this.balanceDirection}--${this.balancePower}`;
            }

            return;
        },
        description() {

            let xName;
            let yName;

            if (this.balanceDirection === "left") {
                xName = this.capitalize(this.balanceData.match);
                yName = this.capitalize(this.balanceData.name);
            } else {
                xName = this.capitalize(this.balanceData.name);
                yName = this.capitalize(this.balanceData.match);
            }

            if (this.balanceData.delta >= 0 && this.balanceData.delta <= 5) {
                return this.$t("balance-quality-description-balanced");
            }

            if (this.balanceData.delta > 5 && this.balanceData.delta <= 15) {
                return this.$t("balance-quality-description-balanced-low");
            }

            if (this.balanceData.delta > 15 && this.balanceData.delta < 30) {
                return this.$t("balance-quality-description-unbalanced-low", {x: xName, y: yName});
            }

            if (this.balanceData.delta > 30 && this.balanceData.delta < 50) {
                return this.$t("balance-quality-description-unbalanced-high", {x: xName, y: yName});
            }

            return this.$t("balance-quality-description-unbalanced-very-high", {x: xName, y: yName});
        }
    },
    mounted: function() {
    },
};

</script>